import * as React from 'react';

import './App.scss';
import Claims from 'views/Claims';
import Claim from 'views/Claim';
import Profile from 'views/Profile';
import Accounts from 'views/Accounts';
import Stores from 'views/Stores';
import Channels from 'views/Channels';
import Alerts from 'views/Alerts';
import Alert from 'views/Alert';

import Navigation from 'components/Navigation';
import { match, Redirect, Route } from 'react-router-dom';
import {
  CLAIMS_PATH,
  claimPath,
  alertPath,
  PROFILE_PATH,
  ACCOUNTS_PATH,
  CHANNELS_PATH,
  STORES_PATH,
  ALERTS_PATH,
} from 'helpers/routes';
import { UserService } from './services/ApiService';
import { UserType } from './types';

require('dotenv').config();

const RestrictedRoute = ({ component, whitelist,  ...rest }) => (
  <Route 
    {...rest}
    render={(props) => (
        whitelist && UserService.getType() !== null && whitelist.indexOf(UserService.getType() as UserType) >= 0
        ? React.createElement(component!!, props)
        : <Redirect to={`/`} />
    )} 
  />
);

class App extends React.Component<{ match: match<{}> }, {}> {
  render() {
    return (
      <div>
        <Navigation />
        <div className="app-content">          
          <Route path={CLAIMS_PATH} exact={true} component={Claims} />
          <Route path={claimPath()} exact={true} component={Claim} />
          <RestrictedRoute path={ALERTS_PATH} exact={true} component={Alerts} whitelist={[UserType.Admin, UserType.QAAdmin]} />
          <RestrictedRoute path={alertPath()} exact={true} component={Alert} whitelist={[UserType.Admin, UserType.QAAdmin]}/>
          <Route path={PROFILE_PATH} component={Profile} />
          <RestrictedRoute path={ACCOUNTS_PATH} component={Accounts} whitelist={[UserType.Admin, UserType.QAAdmin]}/>
          <RestrictedRoute path={STORES_PATH} exact={true} component={Stores} whitelist={[UserType.Admin]}/>
          <RestrictedRoute path={CHANNELS_PATH} exact={true} component={Channels} whitelist={[UserType.LCBOReporter]}/>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx